import { render, staticRenderFns } from "./AdminContactView.vue?vue&type=template&id=475e635c"
import script from "./AdminContactView.vue?vue&type=script&lang=js"
export * from "./AdminContactView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports